import { z } from 'zod';

import { E164_EXAMPLE, E164_RE } from '../../shared/lib/phone';

// Slug rules mirror Phase 5.5's createInstituteSchema so the request-institute
// flow uses the same validation as the admin-side create path.
// eslint-disable-next-line security/detect-unsafe-regex -- bounded char class
const slugRegex = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

export const requestInstituteSchema = z.object({
  name: z.string().trim().min(2, 'Institute name is required').max(120),
  slug: z
    .string()
    .trim()
    .min(3, 'Slug must be at least 3 characters')
    .max(40, 'Slug must be at most 40 characters')
    .regex(slugRegex, 'Lowercase letters, digits, and hyphens only'),
  owner_email: z.string().trim().toLowerCase().email('Enter a valid email'),
  owner_name: z.string().trim().min(2, 'Owner name is required').max(80),
  owner_phone: z.string().trim().regex(E164_RE, `Include country code, e.g. ${E164_EXAMPLE}`),
});

export type RequestInstituteInput = z.infer<typeof requestInstituteSchema>;
